import { push } from 'connected-react-router';
import { BAD_REQUEST_URL, NOT_FOUND_URL } from '../Routes';

export const NOT_FOUND = 'NOT_FOUND';
export const BAD_REQUEST = 'BAD_REQUEST';
export const notFound = (payload) => (dispatch) => {
  dispatch({ type: NOT_FOUND, payload });
  dispatch(push(NOT_FOUND_URL));
};
export const badRequest = (payload) => (dispatch) => {
  dispatch({ type: BAD_REQUEST, payload });
  dispatch(push(BAD_REQUEST_URL));
};
